<app-column [loadingLabel]="loadingLabel" [loading]="!(allChaptersReady$ | async)" [showHeader]="false" [(selectedColumnGroup)]="selectedColumnGroup">
  <!-- Chapters -->
  <app-column-group label="Chapters">
    <ng-container column-group-body>
      <div class="pv-2 pl-2">
        <app-chapter-browser></app-chapter-browser>
      </div>
    </ng-container>
  </app-column-group>

  <!-- Anatomy -->
  <app-column-group label="Anatomy">
    <ng-container column-group-header>
      <div class="navigation-context__anatomy-header">
        <div class="navigation-context__search">
          <input
            type="text"
            class="input navigation-context__input"
            placeholder="Search..."
            [formControl]="searchControl"
            (keyup)="handleKeyup($event)"
            #searchInput>
          <button app-button buttonType="text" class="navigation-context__clear" (click)="clearQuery()" *ngIf="query">Clear</button>
        </div>
  
        <div class="navigation-context__selected">
          <app-checked-nodes></app-checked-nodes>
        </div>      
      </div>
      
    </ng-container>
    <div column-group-body #columnGroupBody>
      <div class="pt-2 ph-2" *ngIf="!query.length" >
        <app-tree></app-tree>
      </div>
  
      <cdk-virtual-scroll-viewport [itemSize]="48" *ngIf="query.length && searchHeight" [style.height.px]="searchHeight" style="margin-right: -12px">
        <div *cdkVirtualFor="let node of searchResults; trackBy: trackTreeNode">
          <app-tree-nested-node style="height: 48px" [node]="node" [graph]="viewGraph$ | async" [nested]="false"></app-tree-nested-node>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </app-column-group>

</app-column>